import React from 'react'
import './Experts.scss';
import ExpertImage from '../../../Assets/Images/expert.png';
export default function Experts() {
    return (
        <>
           <div className="container" id="Technology">
                <div className="expert-grid">
                    <div className="expert-grid-items">
                        <div className="title-text-style">
                            <p>We are the experts you exactly need</p>
                            <h3>We are a Machine Learning Consulting Firm Experienced in AI</h3>
                            <span>
                                We serve as the bridge between startups and AI/ML technologies. By helping you discover 
                                hidden opportunities with machine learning, we empower your business with the intelligence needed to achieve success.
                            </span>
                            <span>
                                We help founders and executives build Artificial Intelligence solutions. We ensure that your product can scale and perform at a higher level 
                                than your competition. We create robust systems that yield insights which you can use to shape your future.
                            </span>
                            <span>
                                We help companies simplify their data analysis and add intelligent features to 
                                systems by using cutting-edge AI technology.
                            </span>
                            {/* <div className="sub-grid sub-grid-top-align">
                                <div className="sub-grid-items">
                                    <i className="far fa-check-circle"></i>
                                    <span>Managed Sucre Backups</span>
                                </div>
                                <div className="sub-grid-items">
                                    <i className="far fa-check-circle"></i>
                                    <span>PHP 7 Ready Servers</span>
                                </div>
                            </div> */}
                            {/* <div className="sub-grid">
                                <div className="sub-grid-items">
                                    <i className="far fa-check-circle"></i>
                                    <span>Advanced Caching</span>
                                </div>
                                <div className="sub-grid-items">
                                    <i className="far fa-check-circle"></i>
                                    <span>24/7 Expert Support</span>
                                </div>
                            </div>
                            <div className="sub-grid"> */}
                                {/* <div className="sub-grid-items">
                                    <i className="far fa-check-circle"></i>
                                    <span>Unlimited Applications</span>
                                </div> */}
                                {/* <div className="sub-grid-items">
                                    <i className="far fa-check-circle"></i>
                                    <span>Optimized Stack</span>
                                </div> */}
                            {/* </div> */}
                            
                        </div>    
                    </div>    
                    <div className="expert-grid-items">
                        <img src={ExpertImage} alt="ExpertImage"/>
                        <div className="nature-img"></div>
                        <div className="nature-img-one"></div>
                    </div>    
                </div>   
            </div> 
        </>
    )
}
